// extracted by mini-css-extract-plugin
export var avatarContainer = "_91-0";
export var avatarTypingWave = "_91-i";
export var gray = "_91-f";
export var green = "_91-c";
export var icon = "_91-9";
export var image = "_91-1";
export var lg = "_91-6";
export var md = "_91-5";
export var presenceDot = "_91-b";
export var red = "_91-d";
export var sm = "_91-4";
export var status = "_91-a";
export var typingDot = "_91-h";
export var typingPill = "_91-g";
export var xl = "_91-7";
export var xs = "_91-3";
export var xxl = "_91-8";
export var xxs = "_91-2";
export var yellow = "_91-e";